import { render, staticRenderFns } from "./DriverInfo.vue?vue&type=template&id=165b9316&scoped=true&"
import script from "./DriverInfo.vue?vue&type=script&lang=js&"
export * from "./DriverInfo.vue?vue&type=script&lang=js&"
import style0 from "./DriverInfo.vue?vue&type=style&index=0&id=165b9316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b9316",
  null
  
)

export default component.exports